import { useEffect, useState } from 'react';
import { base44 } from '@/api/base44Client';

/**
 * Loads the enabled HIPAAtizer form configured for a placement.
 * Returns { form, loading }. form is null when no replacement is configured.
 */
export default function useHipaatizerForm(placement) {
  const [state, setState] = useState({ form: null, loading: true });

  useEffect(() => {
    let active = true;
    setState({ form: null, loading: true });
    base44.entities.HipaatizerForm
      .filter({ placement, enabled: true }, { sort: '-created_date', limit: 1 })
      .then(({ items }) => { if (active) setState({ form: items?.[0] ?? null, loading: false }); })
      .catch(() => { if (active) setState({ form: null, loading: false }); });
    return () => { active = false; };
  }, [placement]);

  return state;
}
